export function Init() {

    let filterGroups = document.getElementsByClassName('filter-group') as HTMLCollectionOf<HTMLDivElement>;

    for (let filterGroup of filterGroups) {
        InitFilterGroup(filterGroup);
    }
}

function InitFilterGroup(filterGroup: HTMLDivElement) {
    if (filterGroup.dataset.initialized !== "true") {

        let grid = GetGrid(filterGroup.dataset.gridname);

        if (grid) {
            filterGroup.dataset.initialized = "true";

            InitClickOnRefreshButtons(grid, filterGroup);
            InitSearchOnEnter(grid, filterGroup);

            InitLockInputsDuringSearch(grid, filterGroup);
        }
    }
}

function GetGrid(gridName: string): MVCxClientGridView {
    return window[gridName] as MVCxClientGridView;
}

function InitClickOnRefreshButtons(grid: MVCxClientGridView, filterGroup: HTMLDivElement) {
    let buttons = filterGroup.getElementsByClassName('external-searchpanel-search-button') as HTMLCollectionOf<HTMLDivElement>;
    for (let button of buttons) {
        button.addEventListener('click', () => grid.Refresh());
    }
}

function InitSearchOnEnter(grid: MVCxClientGridView, filterGroup: HTMLDivElement) {

    let inputs = filterGroup.getElementsByTagName('input');
    for (let input of inputs) {
        input.addEventListener('keypress', (event) => {
            if (event.key === "Enter") {
                grid.Refresh();
            }
        });
    }
}

function InitLockInputsDuringSearch(grid: MVCxClientGridView, filterGroup: HTMLDivElement) {
    grid.BeginCallback.AddHandler((s, e) => {
        $('.filter-group').find(':input').prop('disabled', true);
    });

    grid.EndCallback.AddHandler((s, e) => {
        $('.filter-group').find(':input').prop('disabled', false);
    });
}
